import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import {
  ChevronRight, TrendingUp, Handshake, Trophy, Crown, Gift,
  ArrowDown, ArrowUp, ClipboardList
} from 'lucide-react';

const incomeTypes = [
  { icon: TrendingUp, title: 'ROI Income', desc: '1% daily compounding on your package amount (Mon-Sat)' },
  { icon: Handshake, title: 'Direct Income', desc: 'Level 1: 7%, Level 2: 2%, Level 3: 1% on direct referral packages' },
  { icon: Trophy, title: 'Daily ROI Level', desc: 'Earn from your team ROI up to 30 levels deep' },
  { icon: Crown, title: 'Royalty Income', desc: 'Daily royalty based on team business volume & members' },
  { icon: Gift, title: 'Reward Income', desc: 'One-time rewards based on achieving business milestones' },
];

const compoundingData = [
  { pkg: '₹1,000', d30: '₹347', d60: '₹816', d90: '₹1,448', d180: '₹4,995', d365: '₹36,783' },
  { pkg: '₹5,000', d30: '₹1,739', d60: '₹4,083', d90: '₹7,243', d180: '₹24,979', d365: '₹1,83,917' },
  { pkg: '₹10,000', d30: '₹3,478', d60: '₹8,166', d90: '₹14,486', d180: '₹49,958', d365: '₹3,67,834' },
  { pkg: '₹20,000', d30: '₹6,956', d60: '₹16,333', d90: '₹28,972', d180: '₹99,916', d365: '₹7,35,668' },
  { pkg: '₹50,000', d30: '₹17,392', d60: '₹40,834', d90: '₹72,431', d180: '₹2,49,790', d365: '₹18,39,170' },
  { pkg: '₹1,00,000', d30: '₹34,784', d60: '₹81,669', d90: '₹1,44,863', d180: '₹4,99,580', d365: '₹36,78,340' },
];

export default function IncomePlan() {
  return (
    <>
      <Navbar />

      {/* PAGE BANNER */}
      <section className="page-banner">
        <div className="page-banner-bg" style={{ backgroundImage: 'url(/mlm2.png)' }} />
        <div className="page-banner-overlay" />
        <div className="container page-banner-content">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="breadcrumb-item">Home</Link>
            <ChevronRight size={14} className="breadcrumb-sep" />
            <span className="breadcrumb-item breadcrumb-current">Income Plan</span>
          </nav>
          <h1 className="page-banner-title">
            INCOME <span style={{ color: 'var(--primary-light, #6fa0ff)' }}>PLAN</span>
          </h1>
          <p className="page-banner-sub">
            1% daily ROI with daily compounding, plus five ways to earn as your network grows.
          </p>
        </div>
      </section>

      {/* JOINING PACKAGE */}
      <section className="section" id="package">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">JOINING <span>PACKAGE</span></h2>
            <div className="section-line"></div>
          </div>
          <div className="grid-2" style={{ maxWidth: 700, margin: '0 auto', gap: 24 }}>
            {[
              { label: 'MINIMUM AMOUNT', value: '₹500', icon: ArrowDown },
              { label: 'MAXIMUM AMOUNT', value: '₹5,00,000', icon: ArrowUp },
            ].map(item => (
              <div key={item.label} className="card" style={{ textAlign: 'center' }}>
                <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'center', color: 'var(--primary)' }}><item.icon size={32} /></div>
                <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 8 }}>{item.label}</div>
                <div style={{ fontFamily: 'Rajdhani', fontSize: '2.5rem', fontWeight: 700, color: 'var(--primary)' }}>{item.value}</div>
              </div>
            ))}
          </div>
          <div className="card" style={{ maxWidth: 700, margin: '24px auto 0', borderColor: 'rgba(var(--primary-rgb),0.5)' }}>
            <div style={{ marginBottom: 12, fontWeight: 700, color: 'var(--primary)', display: 'flex', alignItems: 'center', gap: 8 }}><ClipboardList size={18} /> NOTE:</div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 8 }}>
              <li style={{ display: 'flex', gap: 10, color: 'var(--text-light)' }}><span style={{ color: 'var(--primary)' }}>▸</span> Joining will be in multiples of <strong style={{ color: 'var(--primary)' }}>₹500</strong></li>
              <li style={{ display: 'flex', gap: 10, color: 'var(--text-light)' }}><span style={{ color: 'var(--primary)' }}>▸</span> Package will be valid for <strong style={{ color: 'var(--primary)' }}>365 days</strong></li>
            </ul>
          </div>
        </div>
      </section>

      {/* INCOME TYPES */}
      <section className="section section-alt" id="income-types">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">TYPES OF <span>INCOME</span></h2>
            <div className="section-line"></div>
            <p className="section-desc">Build income today, secure freedom tomorrow.</p>
          </div>
          <div className="grid-3">
            {incomeTypes.map(inc => (
              <div key={inc.title} className="income-type-card">
                <div className="income-type-icon"><inc.icon size={24} /></div>
                <div>
                  <div className="income-type-name">{inc.title}</div>
                  <div className="income-type-desc">{inc.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      
      {/* CTA */}
      <section className="section section-relative section-alt" style={{ background: 'linear-gradient(135deg, rgba(var(--secondary-rgb),0.1), rgba(var(--primary-rgb),0.08))' }}>
        <div className="glow-orb-field">
          <div className="glow-orb glow-orb-gold" style={{ top: 'auto', bottom: -80, left: '10%' }}></div>
          <div className="glow-orb glow-orb-blue" style={{ top: -60, right: '15%', bottom: 'auto' }}></div>
        </div>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 style={{ fontFamily: 'Rajdhani', fontSize: 'clamp(1.8rem, 4vw, 3rem)', fontWeight: 700, marginBottom: 16 }}>
            START YOUR <span style={{ color: 'var(--primary)' }}>COMPOUNDING JOURNEY</span>
          </h2>
          <p style={{ color: 'var(--text-light)', marginBottom: 32, maxWidth: 500, margin: '0 auto 32px' }}>
            Join thousands of investors building their financial future with Triveni Pay. Start with just ₹500 today.
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" className="btn btn-primary btn-lg">Join Now It's Free</Link>
            <Link to="/login" className="btn btn-outline btn-lg">Login</Link>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}